export default "__VITE_ASSET__C5JAe6jW__"